var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadPlaystoreBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 56,
    viewBox: "0 0 148 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.7,
    width: 146.6,
    height: 54.6,
    rx: 8.3,
    fill: "white",
    stroke: "#090909",
    strokeWidth: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_5212_7055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5722 14.6745C15.2568 15.0072 15.0703 15.5234 15.0703 16.1919V40.0772C15.0703 40.7468 15.2568 41.262 15.5722 41.5946L15.6525 41.6724L29.0833 28.2923V28.1346V27.9769L15.6525 14.5957L15.5722 14.6745Z",
    fill: "url(#paint0_linear_5212_7055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5592 32.7529L29.083 28.2914V28.1337V27.976L33.5603 23.5156L33.6611 23.5729L38.9656 26.5753C40.4801 27.4328 40.4801 28.8357 38.9656 29.6943L33.6611 32.6967L33.5592 32.7529Z",
    fill: "url(#paint1_linear_5212_7055)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_5212_7055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6615 32.6967L29.0823 28.1348L15.5723 41.5948C16.071 42.1218 16.8959 42.1866 17.825 41.6618L33.6615 32.6967Z",
    fill: "url(#paint2_linear_5212_7055)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.6615 23.5721L17.825 14.6081C16.8959 14.0821 16.071 14.148 15.5723 14.675L29.0833 28.1351L33.6615 23.5721Z",
    fill: "url(#paint3_linear_5212_7055)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.1652 29.4412C71.757 29.4412 69.7942 31.258 69.7942 33.7603C69.7942 36.2474 71.757 38.0794 74.1652 38.0794C76.5744 38.0794 78.5372 36.2474 78.5372 33.7603C78.5361 31.258 76.5734 29.4412 74.1652 29.4412ZM74.1652 36.3794C72.8454 36.3794 71.7078 35.2999 71.7078 33.7613C71.7078 32.2065 72.8464 31.1432 74.1652 31.1432C75.485 31.1432 76.6225 32.2065 76.6225 33.7613C76.6225 35.2988 75.485 36.3794 74.1652 36.3794ZM64.6286 29.4412C62.2204 29.4412 60.2576 31.258 60.2576 33.7603C60.2576 36.2474 62.2204 38.0794 64.6286 38.0794C67.0378 38.0794 69.0006 36.2474 69.0006 33.7603C69.0006 31.258 67.0378 29.4412 64.6286 29.4412ZM64.6286 36.3794C63.3088 36.3794 62.1713 35.2999 62.1713 33.7613C62.1713 32.2065 63.3099 31.1432 64.6286 31.1432C65.9484 31.1432 67.086 32.2065 67.086 33.7613C67.087 35.2988 65.9484 36.3794 64.6286 36.3794ZM53.286 30.7675V32.5995H57.7071C57.575 33.6303 57.229 34.3828 56.7006 34.9058C56.0576 35.5436 55.0511 36.2474 53.286 36.2474C50.5644 36.2474 48.4368 34.0711 48.4368 31.3717C48.4368 28.6724 50.5644 26.4961 53.286 26.4961C54.7542 26.4961 55.8262 27.0689 56.6177 27.8051L57.9211 26.5124C56.8153 25.4653 55.3481 24.6641 53.286 24.6641C49.558 24.6641 46.4238 27.6741 46.4238 31.3717C46.4238 35.0693 49.558 38.0794 53.286 38.0794C55.2979 38.0794 56.8163 37.4244 58.003 36.1976C59.2235 34.9871 59.6034 33.285 59.6034 31.911C59.6034 31.4865 59.5706 31.0935 59.504 30.7665L53.286 30.7675ZM99.6764 32.1903C99.314 31.2255 98.2082 29.4412 95.9485 29.4412C93.7051 29.4412 91.8406 31.192 91.8406 33.7603C91.8406 36.1814 93.6887 38.0794 96.1625 38.0794C98.158 38.0794 99.313 36.8689 99.7921 36.1651L98.3075 35.1831C97.813 35.9031 97.1362 36.3774 96.1625 36.3774C95.1898 36.3774 94.4966 35.9356 94.0512 35.0683L99.8741 32.6798L99.6764 32.1903ZM93.7379 33.6303C93.6887 31.9607 95.0413 31.1107 96.015 31.1107C96.7737 31.1107 97.4167 31.4875 97.6317 32.0268L93.7379 33.6303ZM89.0044 37.8184H90.9171V25.1231H89.0044V37.8184ZM85.8693 30.407H85.8037C85.3747 29.8992 84.5495 29.4412 83.5112 29.4412C81.3334 29.4412 79.3379 31.3392 79.3379 33.7776C79.3379 36.1986 81.3334 38.0804 83.5112 38.0804C84.5505 38.0804 85.3747 37.6224 85.8037 37.0994H85.8693V37.7209C85.8693 39.3732 84.9785 40.2567 83.544 40.2567C82.3727 40.2567 81.6467 39.423 81.3498 38.7192L79.6839 39.4067C80.1621 40.5512 81.4317 41.9588 83.544 41.9588C85.7873 41.9588 87.6846 40.6497 87.6846 37.4589V29.7042H85.8703L85.8693 30.407ZM83.6761 36.3794C82.3563 36.3794 81.2515 35.2826 81.2515 33.7776C81.2515 32.2553 82.3563 31.1432 83.6761 31.1432C84.9785 31.1432 86.0013 32.2553 86.0013 33.7776C86.0013 35.2826 84.9785 36.3794 83.6761 36.3794ZM108.64 25.1231H104.062V37.8184H105.971V33.0088H108.639C110.756 33.0088 112.839 31.4885 112.839 29.0664C112.839 26.6444 110.757 25.1231 108.64 25.1231ZM108.689 31.2417H105.971V26.8901H108.689C110.117 26.8901 110.928 28.0631 110.928 29.0664C110.928 30.0495 110.117 31.2417 108.689 31.2417ZM120.496 29.4188C119.113 29.4188 117.681 30.0231 117.088 31.3626L118.783 32.0643C119.146 31.3626 119.822 31.1331 120.529 31.1331C121.517 31.1331 122.522 31.7211 122.538 32.7661V32.8971C122.192 32.7011 121.451 32.4076 120.545 32.4076C118.718 32.4076 116.856 33.4038 116.856 35.2653C116.856 36.9643 118.355 38.0581 120.034 38.0581C121.318 38.0581 122.027 37.4863 122.471 36.8161H122.537V37.7961H124.382V32.9286C124.383 30.6761 122.685 29.4188 120.496 29.4188ZM120.265 36.3763C119.64 36.3763 118.767 36.0656 118.767 35.2978C118.767 34.3178 119.854 33.9421 120.793 33.9421C121.632 33.9421 122.028 34.1218 122.538 34.3666C122.389 35.5436 121.369 36.3763 120.265 36.3763ZM131.101 29.6961L128.911 35.2003H128.845L126.572 29.6961H124.514L127.923 37.3888L125.979 41.6683H127.972L133.225 29.6961H131.101ZM113.893 37.8184H115.803V25.1231H113.893V37.8184Z",
    fill: "#090909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0472 17.6134C53.0472 18.449 52.7935 19.1141 52.285 19.6107C51.7081 20.201 50.9552 20.4962 50.0304 20.4962C49.1445 20.4962 48.3906 20.197 47.7717 19.5987C47.1518 18.9995 46.8418 18.2576 46.8418 17.3721C46.8418 16.4857 47.1518 15.7438 47.7717 15.1455C48.3906 14.5462 49.1445 14.2471 50.0304 14.2471C50.4703 14.2471 50.8907 14.3308 51.2897 14.4973C51.6897 14.6649 52.0099 14.8872 52.2492 15.1654L51.7101 15.6919C51.304 15.2183 50.7444 14.982 50.0294 14.982C49.3829 14.982 48.8243 15.2033 48.3527 15.6461C47.8811 16.0888 47.6459 16.6641 47.6459 17.3711C47.6459 18.0781 47.8811 18.6534 48.3527 19.0962C48.8243 19.5389 49.3829 19.7603 50.0294 19.7603C50.7148 19.7603 51.2866 19.5379 51.7439 19.0922C52.0406 18.802 52.2124 18.3982 52.2584 17.8807H50.0294V17.1617H53.0032C53.0339 17.3183 53.0472 17.4688 53.0472 17.6134Z",
    fill: "#090909"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7632 15.1146H54.9684V17.0112H57.489V17.7301H54.9684V19.6267H57.7632V20.3626H54.1797V14.3797H57.7632V15.1146Z",
    fill: "#090909"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0888 20.3626H60.3V15.1146H58.5855V14.3797H62.8033V15.1146H61.0888V20.3626Z",
    fill: "#090909"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8548 20.3626V14.3797H66.6435V20.3626H65.8548Z",
    fill: "#090909"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1412 20.3626H69.3525V15.1146H67.638V14.3797H71.8557V15.1146H70.1412V20.3626Z",
    fill: "#090909"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8398 19.5898C79.2362 20.1941 78.4864 20.4962 77.5892 20.4962C76.6921 20.4962 75.9422 20.1941 75.3397 19.5898C74.7362 18.9855 74.4354 18.2457 74.4354 17.3712C74.4354 16.4967 74.7362 15.7568 75.3397 15.1525C75.9422 14.5482 76.6921 14.2451 77.5892 14.2451C78.4813 14.2451 79.2301 14.5492 79.8357 15.1565C80.4413 15.7638 80.7441 16.5017 80.7441 17.3712C80.7441 18.2457 80.4423 18.9855 79.8398 19.5898ZM75.9218 19.0883C76.376 19.537 76.9315 19.7603 77.5892 19.7603C78.247 19.7603 78.8035 19.536 79.2567 19.0883C79.7109 18.6395 79.939 18.0672 79.939 17.3712C79.939 16.6752 79.7109 16.1028 79.2567 15.6541C78.8035 15.2054 78.247 14.982 77.5892 14.982C76.9315 14.982 76.376 15.2064 75.9218 15.6541C75.4686 16.1028 75.2405 16.6752 75.2405 17.3712C75.2405 18.0672 75.4686 18.6395 75.9218 19.0883Z",
    fill: "#090909"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.851 20.3626V14.3797H82.8105L85.7935 19.0334H85.8273L85.7935 17.8807V14.3797H86.5822V20.3626H85.7587L82.6376 15.4826H82.6039L82.6376 16.6353V20.3626H81.851Z",
    fill: "#090909"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0472 17.6134C53.0472 18.449 52.7935 19.1141 52.285 19.6107C51.7081 20.201 50.9552 20.4962 50.0304 20.4962C49.1445 20.4962 48.3906 20.197 47.7717 19.5987C47.1518 18.9995 46.8418 18.2576 46.8418 17.3721C46.8418 16.4857 47.1518 15.7438 47.7717 15.1455C48.3906 14.5462 49.1445 14.2471 50.0304 14.2471C50.4703 14.2471 50.8907 14.3308 51.2897 14.4973C51.6897 14.6649 52.0099 14.8872 52.2492 15.1654L51.7101 15.6919C51.304 15.2183 50.7444 14.982 50.0294 14.982C49.3829 14.982 48.8243 15.2033 48.3527 15.6461C47.8811 16.0888 47.6459 16.6641 47.6459 17.3711C47.6459 18.0781 47.8811 18.6534 48.3527 19.0962C48.8243 19.5389 49.3829 19.7603 50.0294 19.7603C50.7148 19.7603 51.2866 19.5379 51.7439 19.0922C52.0406 18.802 52.2124 18.3982 52.2584 17.8807H50.0294V17.1617H53.0032C53.0339 17.3183 53.0472 17.4688 53.0472 17.6134Z",
    stroke: "white",
    strokeWidth: 0.0409023,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7632 15.1146H54.9684V17.0112H57.489V17.7301H54.9684V19.6267H57.7632V20.3626H54.1797V14.3797H57.7632V15.1146Z",
    stroke: "white",
    strokeWidth: 0.0409023,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0888 20.3626H60.3V15.1146H58.5855V14.3797H62.8033V15.1146H61.0888V20.3626Z",
    stroke: "white",
    strokeWidth: 0.0409023,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8548 20.3626V14.3797H66.6435V20.3626H65.8548Z",
    stroke: "white",
    strokeWidth: 0.0409023,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1412 20.3626H69.3525V15.1146H67.638V14.3797H71.8557V15.1146H70.1412V20.3626Z",
    stroke: "white",
    strokeWidth: 0.0409023,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8398 19.5898C79.2362 20.1941 78.4864 20.4962 77.5892 20.4962C76.6921 20.4962 75.9422 20.1941 75.3397 19.5898C74.7362 18.9855 74.4354 18.2457 74.4354 17.3712C74.4354 16.4967 74.7362 15.7568 75.3397 15.1525C75.9422 14.5482 76.6921 14.2451 77.5892 14.2451C78.4813 14.2451 79.2301 14.5492 79.8357 15.1565C80.4413 15.7638 80.7441 16.5017 80.7441 17.3712C80.7441 18.2457 80.4423 18.9855 79.8398 19.5898ZM75.9218 19.0883C76.376 19.537 76.9315 19.7603 77.5892 19.7603C78.247 19.7603 78.8035 19.536 79.2567 19.0883C79.7109 18.6395 79.939 18.0672 79.939 17.3712C79.939 16.6752 79.7109 16.1028 79.2567 15.6541C78.8035 15.2054 78.247 14.982 77.5892 14.982C76.9315 14.982 76.376 15.2064 75.9218 15.6541C75.4686 16.1028 75.2405 16.6752 75.2405 17.3712C75.2405 18.0672 75.4686 18.6395 75.9218 19.0883Z",
    stroke: "white",
    strokeWidth: 0.0409023,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81.851 20.3626V14.3797H82.8105L85.7935 19.0334H85.8273L85.7935 17.8807V14.3797H86.5822V20.3626H85.7587L82.6376 15.4826H82.6039L82.6376 16.6353V20.3626H81.851Z",
    stroke: "white",
    strokeWidth: 0.0409023,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_5212_7055",
    x: 15.0703,
    y: 14.2451,
    width: 25.0312,
    height: 27.7793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.159
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5212_7055"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.159
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_5212_7055",
    result: "effect2_innerShadow_5212_7055"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_5212_7055",
    x: 15.5723,
    y: 28.1348,
    width: 18.0889,
    height: 13.8896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.159
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5212_7055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5212_7055",
    x1: 27.8928,
    y1: 15.9392,
    x2: 9.76834,
    y2: 34.1324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5212_7055",
    x1: 40.937,
    y1: 28.1337,
    x2: 14.7064,
    y2: 28.1337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5212_7055",
    x1: 31.1747,
    y1: 30.6122,
    x2: 6.59567,
    y2: 55.2844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5212_7055",
    x1: 12.1697,
    y1: 6.72386,
    x2: 23.1449,
    y2: 17.7407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPlaystoreBtn);
export default __webpack_public_path__ + "static/media/download-playstore-btn.d907033cf0d2a86fc29126382630d580.svg";
export { ForwardRef as ReactComponent };